import React from 'react'

import icon39 from "../../assets/images/icon-39.png"
import icon40 from "../../assets/images/icon-40.png"
import icon41 from "../../assets/images/icon-41.png"
import icon42 from "../../assets/images/icon-42.png"

import Icon1 from "../../assets/images/icon-7.png"
import Icon2 from "../../assets/images/icon-6.png"
import { Link } from 'react-router-dom'
import { config } from '../pages/config'

const CourseCard = ({ course }) => {
    return (
        <div className="col-lg-6 col-md-12 col-sm-12 course-block">
            <div className="course-block-one">
                <div className="inner-box">
                    <div className="image-box">
                        <div className="price">
                            <h2>
                                {/* <span className="text">From</span> */}
                                <span className="symble">£</span>{course.price}
                                {/* <div className='fs-6 lh-sm fw-normal'>Per Person</div> */}
                            </h2>
                        </div>
                        <figure className="image">
                            <img src={course.imageUrl} alt="" />
                        </figure>
                    </div>
                    <div className="content-box">
                        <div >
                            <p >
                                {course.description.slice(0, 40)}
                                {course.description.length > 47 && "..."}
                            </p>
                        </div>
                        <div className="single-box">
                            <div className="single-item">
                                <div className="icon-box">
                                    <img src={Icon1} alt="" />
                                </div>
                                <h6>Theory Session</h6>
                                <span>{course.theory}</span>
                            </div>
                            <div className="single-item">
                                <div className="icon-box">
                                    <img src={Icon2} alt="" />
                                </div>
                                <h6>Practical Session</h6>
                                <span>{course.practical} Hours</span>
                            </div>
                        </div>
                        <div className="btn-box">
                            <Link to={`${config.appUrl}course/${course.id}`}>Read More</Link>
                        </div>
                    </div>
                </div>
                <div className="lower-box">
                    <div className="icon-box">
                        <img src={icon41} alt="" />
                    </div>
                    <div className="icon-box-2">
                        <img src={icon42} alt="" />
                    </div>
                    <h6>{course.cartype}</h6>
                    <h3>
                        <Link to={`${config.appUrl}course/${course.id}`}>{course.title}</Link>
                    </h3>
                </div>
            </div>
        </div>
    )
}

export default CourseCard